/*
 * Keeps the cart drawer in sync with Zepto Product Personalizer.
 *
 * After the theme adds a personalized item, Zepto rewrites the line item
 * (1-2 /cart/change.js calls, ~0.5-2s later) to attach its _pplr_* properties.
 * That changes the line key, so the drawer's Remove/quantity controls point at
 * a key that no longer exists ("no valid id or line parameter").
 *
 * Zepto also replaces window.fetch / XMLHttpRequest.open with its own
 * wrappers, so hooking its requests is unreliable. Instead, once the drawer
 * opens, poll the cart briefly and re-render the drawer when its keys go stale.
 */
(function () {
  // ~5s window; Zepto also polls cart.js, so keep the rate low to avoid 503 throttling.
  var POLL_INTERVAL = 1000;
  var POLL_TRIES = 5;
  var pollRun = 0;

  function unique(list) {
    return list.filter(function (v, i) { return list.indexOf(v) === i; });
  }

  function drawerKeys() {
    var els = document.querySelectorAll('#cart-drawer [data-line-key]');
    return unique(Array.prototype.map.call(els, function (el) {
      return el.getAttribute('data-line-key');
    })).sort().join('|');
  }

  function syncDrawer() {
    var run = ++pollRun;
    var tries = 0;
    (function check() {
      if (run !== pollRun || tries++ >= POLL_TRIES) return;
      fetch(window.Shopify.routes.root + 'cart.js', { cache: 'no-store' })
        .then(function (r) {
          if (!r.ok) throw new Error('cart.js ' + r.status);
          return r.json();
        })
        .then(function (cart) {
          var cartKeys = cart.items.map(function (i) { return i.key; }).sort().join('|');
          if (cartKeys !== drawerKeys()) {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
          setTimeout(check, POLL_INTERVAL);
        })
        .catch(function () { setTimeout(check, POLL_INTERVAL); });
    })();
  }

  function closePersonalizerPopup() {
    var btn = document.querySelector('.pplr-main a.js-modal-close.pplr_close.p_r_c');
    if (btn) btn.click();
    else if (typeof window.pplr_w_h === 'function') window.pplr_w_h();
  }

  // dialog:after-show does not bubble, so listen in the capture phase.
  document.addEventListener('dialog:after-show', function (e) {
    if (!e.target || e.target.id !== 'cart-drawer') return;
    closePersonalizerPopup();
    syncDrawer();
  }, true);
})();
